import { Button, Table, Tooltip } from '@roo/roo';
import { Column } from '@roo/roo/Table';
import * as React from 'react';
import {
    ApprovedStatusEnum,
    ApprovedStatusZH,
    IListProps,
    IServiceItem,
    OnlineActEnum,
    OnlineStatusEnum,
    OwnFlagEnum,
    PunishStatusEnum,
    PunishStatusZH,
    RefTypeEnum,
    ServiceStatusEnum,
} from '../api';
import LogoInfo from './serviceInfo';
import OnlieModal from './onlineModal';
import DelModal from './delModal';
import CopyButton from './copyButton';
import QRcodeButton from './qrcodeButton';

const { useState } = React;

const Index = (prop: IListProps) => {
    const { list, refresh, tableLoading } = prop;
    const [onlineModalVisible, setOnlineModalVisible] = useState<boolean>(false);
    const [delModalVisible, setDelModalVisible] = useState<boolean>(false);
    const [currentService, setCurrentService] = useState<IServiceItem>();

    // 上下架的展示逻辑
    const renderOnline = (data: IServiceItem) => {
        const text = data.onlineStatus === OnlineStatusEnum.online ? '下架' : '上架';
        if (data.actStatus === OnlineActEnum.hasAct) {
            return (
                <Tooltip content="该服务存在当前活动，不可修改" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.punishStatus !== PunishStatusEnum.normal) {
            return (
                <Tooltip content="该服务正在被处罚" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.approvedStatus === ApprovedStatusEnum.wait) {
            return (
                <Tooltip content="该服务资料状态为审核中" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        return (
            <Button
                type="text"
                onClick={() => {
                    setCurrentService(data);
                    setOnlineModalVisible(true);
                }}
            >
                {text}
            </Button>
        );
    };

    // 编辑的展示逻辑
    const renderEdit = (data: IServiceItem) => {
        const text = '编辑';
        if (data.actStatus === OnlineActEnum.hasAct) {
            return (
                <Tooltip content="该服务存在当前活动，不可修改" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.punishStatus === PunishStatusEnum.dropOff) {
            return (
                <Tooltip content="该服务处罚状态为永久下架" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.punishStatus === PunishStatusEnum.rest) {
            return (
                <Tooltip content="该服务处罚状态为冻结" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.approvedStatus === ApprovedStatusEnum.wait) {
            return (
                <Tooltip content="该服务资料状态为审核中" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.refType === RefTypeEnum.outer) {
            return (
                <Tooltip content="外链跳转的服务" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        return (
            <Button
                type="text"
                onClick={() => {
                    window.location.hash = `/main/v3/add?serviceID=${data.serviceID}&serviceAuditID=${data.serviceAuditID}`;
                }}
            >
                {text}
            </Button>
        );
    };

    // 删除的展示逻辑
    const renderDel = (data: IServiceItem) => {
        const text = '删除';
        if (data.actStatus === OnlineActEnum.hasAct) {
            return (
                <Tooltip content="该服务存在当前活动，不可修改" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        if (data.punishStatus === PunishStatusEnum.rest) {
            return (
                <Tooltip content="该服务处罚状态为冻结" placement="bottom">
                    <Button type="text" disabled>
                        {text}
                    </Button>
                </Tooltip>
            );
        }
        return (
            <Button
                type="text"
                onClick={() => {
                    setCurrentService(data);
                    setDelModalVisible(true);
                }}
            >
                {text}
            </Button>
        );
    };

    const columns: Column<IServiceItem>[] = [
        {
            prop: 'name',
            label: '服务资料',
            render(text, record) {
                return <LogoInfo service={record} />;
            },
        },
        {
            prop: 'serviceID',
            label: '商品id',
        },
        {
            prop: 'status',
            label: '资料状态',
            render(text, record) {
                return (
                    <>
                        <p>{ApprovedStatusZH[record.approvedStatus]}</p>
                        {record.approvedStatus === ApprovedStatusEnum.notPass ? (
                            <p style={{ color: '#FF001F' }}>{record.opinion}</p>
                        ) : null}
                    </>
                );
            },
        },
        {
            prop: 'punishStatus',
            label: '处罚状态',
            render(text, record) {
                return (
                    <>
                        <p>
                            <span>{PunishStatusZH[record.punishStatus]}</span>
                            {record.punishStatus === PunishStatusEnum.rest ? (
                                <span>{record.pauseDay}天</span>
                            ) : null}
                        </p>
                        {record.punishStatus === PunishStatusEnum.rest ? (
                            <p style={{ color: '#FF001F' }}>{record.releaseTime}恢复</p>
                        ) : null}
                    </>
                );
            },
        },
        {
            prop: 'handle',
            label: '操作',
            render(text, record) {
                return (
                    <>
                        {record.ownFlag === OwnFlagEnum.own && (
                            <>
                                <p style={{ margin: '0' }}>
                                    {renderOnline(record)}
                                    &nbsp;
                                    {renderEdit(record)}
                                    &nbsp;
                                    {renderDel(record)}
                                </p>
                            </>
                        )}
                        <p style={{ margin: '0' }}>
                            <CopyButton
                                id={record.serviceID}
                                ownFlag={record.ownFlag}
                                name={record.serviceName}
                            />
                        </p>
                        <p style={{ margin: '0' }}>
                            <QRcodeButton id={record.serviceID} />
                        </p>
                    </>
                );
            },
        },
    ];

    const renderEmpty = () => {
        const imgUrl =
            'https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/pic-manager/f2883475d7659e04/empty-box.png';
        return (
            <div className="noService">
                <img src={imgUrl} alt="" />
                <p className="txt">您还没有服务哟，赶快去新建服务吧~</p>
            </div>
        );
    };

    return (
        <>
            <Table
                rowKey="serviceAuditID"
                rowClassName={(index, data) => {
                    if (data.serviceStatus === ServiceStatusEnum.unShow) return 'unshow';
                    return '';
                }}
                columns={columns}
                data={list}
                loading={tableLoading}
                emptyComponent={renderEmpty()}
            />
            <OnlieModal
                visible={onlineModalVisible}
                handleClose={() => {
                    setOnlineModalVisible(false);
                }}
                refresh={refresh}
                service={currentService}
            />
            <DelModal
                visible={delModalVisible}
                handleClose={() => {
                    setDelModalVisible(false);
                }}
                refresh={refresh}
                service={currentService}
            />
        </>
    );
};

export default Index;
